var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "truck",
    width: 20.432,
    height: 14.164,
    viewBox: "0 0 20.432 14.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#2e2d79}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601",
    transform: "translate(2.425 9.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    d: "M324.726 304.4a2.575 2.575 0 1 1-2.575 2.575 2.578 2.578 0 0 1 2.575-2.575zm0 3.863a1.288 1.288 0 1 0-1.288-1.288 1.289 1.289 0 0 0 1.288 1.291z",
    className: "cls-1",
    "data-name": "Path 6647",
    transform: "translate(-322.151 -304.403)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(11.224 9.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    d: "M104.222 304.4a2.575 2.575 0 1 1-2.575 2.575 2.578 2.578 0 0 1 2.575-2.575zm0 3.863a1.288 1.288 0 1 0-1.288-1.288 1.289 1.289 0 0 0 1.288 1.291z",
    className: "cls-1",
    "data-name": "Path 6648",
    transform: "translate(-101.647 -304.403)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(1.335 1.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    d: "M332.688 111.145a.644.644 0 0 1 .575-.355h3.391v1.288h-2.994l-1.753 3.487-1.151-.579z",
    className: "cls-1",
    "data-name": "Path 6649",
    transform: "translate(-330.756 -110.79)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(6.932 10.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_342",
    d: "M0 0H4.872V1.288H0z",
    className: "cls-1",
    "data-name": "Rectangle 342"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609",
    transform: "translate(15.088 10.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6650",
    d: "M46.359 353.345h2.232a.644.644 0 1 1 0 1.288h-2.232a.644.644 0 1 1 0-1.288z",
    className: "cls-1",
    "data-name": "Path 6650",
    transform: "translate(-45.715 -353.345)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    d: "M45.85 85.552l1.266-1.631a.643.643 0 0 1 .508-.249H52.3v-4.507a.644.644 0 0 1 .644-.644h10.734a.644.644 0 1 1 0 1.288H53.591v4.507a.644.644 0 0 1-.644.644H47.94L47 86.167v3.321h1.781a.644.644 0 1 1 0 1.288h-2.422a.644.644 0 0 1-.644-.644v-4.185a.645.645 0 0 1 .135-.395z",
    className: "cls-1",
    "data-name": "Path 6651",
    transform: "translate(-45.715 -78.521)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(15.131 7.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    d: "M27 271.6h2.962a.644.644 0 1 1 0 1.288H27a.644.644 0 0 1 0-1.288z",
    className: "cls-1",
    "data-name": "Path 6652",
    transform: "translate(-26.353 -271.597)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(13.65 5.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6653",
    d: "M.644 208.134h5.494a.644.644 0 0 1 0 1.288H.644a.644.644 0 0 1 0-1.288z",
    className: "cls-1",
    "data-name": "Path 6653",
    transform: "translate(0 -208.134)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617",
    transform: "translate(12.598 2.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6654",
    d: "M27 144.672h5.494a.644.644 0 1 1 0 1.288H27a.644.644 0 1 1 0-1.288z",
    className: "cls-1",
    "data-name": "Path 6654",
    transform: "translate(-26.353 -144.672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.a377a96c1595f701e759db5ecd8ca430.svg";
export { ForwardRef as ReactComponent };